import { createContext, useContext } from 'react';

const noop = () => {};
export const GameStartAccountOfferContext = createContext({ requestOffer: noop, cancelOffer: noop, cancelPendingOffer: noop, setGamePresentationPending: noop, setGameplayActive: noop, hasPendingOffer: false, gamePresentationPending: false, isGameplayActive: false });

// Preview renderers and the admin portal do not mount the offer provider.
export const useGameStartAccountOffer = () => useContext(GameStartAccountOfferContext);
